export default "__VITE_ASSET__hI3B$dyt__"